<template>
    <div>
        <div class="alert-warning">
            {{ this.errorMessage }}
        </div>
        <label>
            <strong>Session ID</strong>
            <input type="text" v-model="sessionId">
        </label>
        <label>
            <strong>Session data</strong>
            <input type="text" v-model="sessionData">
        </label>
        <button @click="submit">Submit</button>

        <div id="dropin-container"></div>
    </div>
</template>
<script>
import AdyenCheckout from "@adyen/adyen-web";
import "@adyen/adyen-web/dist/adyen.css";

export default {
    name: "AdyenDropIn",
    props: {
        adyenClientKey: {
            required: true
        }
    },
    data() {
        return {
            sessionId: null,
            sessionData: null,
            errorMessage: null
        }
    },
    methods: {
        async submit() {
            this.errorMessage = null;
            const configuration = {
                environment: 'test', // Hardcoded to test because we only want to use this on test envs
                clientKey: this.adyenClientKey,
                analytics: {
                    enabled: true
                },
                session: {
                    id: this.sessionId,
                    sessionData: this.sessionData
                },
                onPaymentCompleted: (result, component) => {
                    console.info(result, component);
                },
                onError: (error, component) => {
                    console.error(error.name, error.message, error.stack, component);
                    this.errorMessage = error.message;
                }
            }
            const checkout = await AdyenCheckout(configuration);
            checkout.create('dropin').mount('#dropin-container');
        }
    }
}
</script>
<style scoped>

</style>
